export function removeDuplicateParticipants(participants) {
  return participants.filter((value, index, self) =>
    index === self.findIndex((t) => (
      t.id === value.id || t.name === value.name
    ))
  )
}

